import React, { ChangeEvent, FunctionComponent, useContext } from "react";
import { v1 as uuidv1 } from "uuid";
import { Plan } from "../../../@types";
import { AppStore } from "../../../app/store";
import { getPlanName } from "../../../helpers/planHelpers";

const PlanRadioInput: FunctionComponent<{
  plan: Plan;
  setSelectedPlan: (plan: Plan) => void;
  selectedPlan: Plan | undefined;
}> = ({ plan, setSelectedPlan, selectedPlan }) => {
  const id = uuidv1();
  const {
    state: { language },
  } = useContext(AppStore.AppContext);
  const checked = plan.id === selectedPlan?.id;

  return (
    <div className="PlanComparePage__planRadioInput">
      <input
        type="radio"
        id={id}
        name="plan-options"
        checked={checked}
        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
          const { checked } = event.currentTarget;

          if (checked) {
            setSelectedPlan(plan);
          }
        }}
      />
      <label htmlFor={id}>{getPlanName(plan, language)}</label>
    </div>
  );
};

export default PlanRadioInput;
